import { setPortfolioUsedAtToLocalStorage } from '@/localStorage'
import type { Portfolio } from '@/types'
import { AuthTokenExpiredException } from '@pkg/basic'
import { apiClient } from '../constants'

export const updateLastUsedAt = async (params: {
  portfolio: Portfolio
  getToken: () => Promise<string | null>
}) => {
  const { portfolio, getToken } = params

  const token = await getToken()
  if (token === null) {
    throw new AuthTokenExpiredException()
  }
  const now = Date.now()
  setPortfolioUsedAtToLocalStorage(now, true)
  const response = await apiClient.v1.portfolio[':id'].use.$post(
    {
      json: {
        timestamp: now,
      },
      param: { id: portfolio.uuid },
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    },
  )
  if (!response.ok) {
    throw new Error(
      `Failed to update lastUsed: ${response.status} ${response.statusText}`,
    )
  }
}
